'use client';

import { AppLayoutWrapper } from '~/_components/app-layout-wrapper';

export function FeedLayoutClient({ children }: { children: React.ReactNode }) {
  return <AppLayoutWrapper showCoinBalance={true}>{children}</AppLayoutWrapper>;
}
